import {Radio} from '@mui/material';

import {ModuleGeneralLeaderboardVisibility} from '../../../../../types/entities/ModuleType';

type ChangeGeneralLeaderboardVisibilityProps = {
  selectedValue: ModuleGeneralLeaderboardVisibility;
  handleChange: (newVisibility: ModuleGeneralLeaderboardVisibility) => void;
};

function ChangeGeneralLeaderboardVisibility({selectedValue, handleChange}: ChangeGeneralLeaderboardVisibilityProps) {
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <h2 className="font-bold text-2xl text-gray-200">Leaderboard Name Visibility</h2>
        <p>
          Select how student names appear in all leaderboards: as their real names, nicknames, or completely anonymous.
          This setting only affects the way <span className="font-semibold">students</span> see the leaderboards, all
          other roles (e.g. Course-Admins, Teachers) will see their real names. Also, no matter the setting, students
          will still see their own real names.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 select-none">
        {[
          {
            value: 'realname',
            label: 'Real names',
            description: "Students see each other's real names in all leaderboards",
          },
          {
            value: 'nickname',
            label: 'Nicknames',
            description: "Students see each other's nickname in all leaderboards",
          },
          {
            value: 'anonymous',
            label: 'Anonymous',
            description: "Students do not see at all each other's names in all leaderboards",
          },
        ].map(({value, label, description}) => (
          <label
            key={value}
            className="relative flex items-center p-4 rounded-lg shadow-sm border hover:shadow-md transition-all duration-200 cursor-pointer peer-checked:ring-2 peer-checked:ring-black hover:bg-primary-main "
          >
            <input
              type="radio"
              name="leaderboard"
              value={value}
              checked={selectedValue === value}
              onChange={() => handleChange(value as ModuleGeneralLeaderboardVisibility)}
              className="hidden peer"
            />
            <div className={`absolute inset-0 rounded-lg opacity-0 peer-checked:opacity-100 transition bg-[#415D1D]`} />
            <Radio
              checked={selectedValue === value}
              onClick={(event) =>
                handleChange((event.target as HTMLInputElement).value as ModuleGeneralLeaderboardVisibility)
              }
              value={value}
            />
            <div className="ml-3 relative z-10">
              <label className="font-semibold text-lg">{label}</label>
              <p className="text-sm">{description}</p>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}

export default ChangeGeneralLeaderboardVisibility;
